// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-container[data-v-633a9076] {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background-color: #000;
  overflow: hidden;
  border-radius: 8px;
}
video[data-v-633a9076] {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  border-radius: 8px;
}
.main-video[data-v-633a9076] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}
.mini-video[data-v-633a9076] {
  position: absolute;
  width: 25%;
  height: 25%;
  aspect-ratio: 16/9;
  top: 16px;
  right: 16px;
  border-radius: 8px;
  z-index: 2;
  cursor: move;
}
.controls-overlay[data-v-633a9076] {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  gap: 12px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  transition: opacity 0.3s ease;
  opacity: 1;
  pointer-events: auto;
  min-height: 8px;
}
.controls-overlay.hidden[data-v-633a9076] {
  opacity: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/community/DirectVideoPage.vue","webpack://./DirectVideoPage.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;ACDF;ADIA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;ACDF;ADIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;ACDF;ADIA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;ACDF;ADIA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;EACA,oBAAA;EACA,eAAA;ACDF;ADGE;EACE,UAAA;EACA,oBAAA;ACDJ","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.video-container {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16/9;\n  background-color: #000;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\nvideo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center center;\n  border-radius: 8px;\n}\n\n.main-video {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.mini-video {\n  position: absolute;\n  width: 25%;\n  height: 25%;\n  aspect-ratio: 16/9;\n  top: 16px;\n  right: 16px;\n  border-radius: 8px;\n  z-index: 2;\n  cursor: move;\n}\n\n.controls-overlay {\n  position: absolute;\n  bottom: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 3;\n  display: flex;\n  gap: 12px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 8px;\n  transition: opacity 0.3s ease;\n  opacity: 1;\n  pointer-events: auto;\n  min-height: 8px;\n\n  &.hidden {\n    opacity: 0;\n    pointer-events: none;\n  }\n}\n",".video-container {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16/9;\n  background-color: #000;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\nvideo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center center;\n  border-radius: 8px;\n}\n\n.main-video {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.mini-video {\n  position: absolute;\n  width: 25%;\n  height: 25%;\n  aspect-ratio: 16/9;\n  top: 16px;\n  right: 16px;\n  border-radius: 8px;\n  z-index: 2;\n  cursor: move;\n}\n\n.controls-overlay {\n  position: absolute;\n  bottom: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 3;\n  display: flex;\n  gap: 12px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 8px;\n  transition: opacity 0.3s ease;\n  opacity: 1;\n  pointer-events: auto;\n  min-height: 8px;\n}\n.controls-overlay.hidden {\n  opacity: 0;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
